export const SendMail = code => ({
  type: 'SEND_MAIL',
  payload: {
    client: 'sandbox',
    request: {
      method: 'get',
      url: `/shipping/${code}`
    }
  }
})

export const ValidationNameSuccess = () => ({
  type: 'VALIDATION_NAME_SUCCESS'
})

export const ValidationNameFail = () => ({
  type: 'VALIDATION_NAME_FAIL'
})

export const ValidationMailSuccess = () => ({
  type: 'VALIDATION_MAIL_SUCCESS'
})

export const ValidationMailFail = () => ({
  type: 'VALIDATION_MAIL_FAIL'
})



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Unvailable/actions.js